import { Input, Popover } from 'antd';
import {
  StyledPopover,
  StyledSearchInputWithTypes,
} from './SearchInputWithTypes.styled';
import ActivityTypeIcon from '../ActivityTypeIcon/ActivityTypeIcon';
import Colors from '@/constants/Colors';
import ActivityTypes from '@/constants/ActivityTypes';
import { useState } from 'react';
import { ChevronDown, ChevronUp } from '@styled-icons/boxicons-regular';

export default function SearchInputWithTypes({
  inputRef,
  value,
  onChange,
  selectedActivityType,
  onActivityTypeChange,
  allowClear,
}) {
  const label = selectedActivityType
    ? ActivityTypes.withLabels.find(
        (activityType) => activityType.value == selectedActivityType
      )?.label
    : 'themes';

  return (
    <StyledSearchInputWithTypes>
      <Input
        addonBefore={
          <ActivityTypeSearch
            selectedActivityType={selectedActivityType}
            onActivityTypeChange={onActivityTypeChange}
          />
        }
        className="input"
        ref={inputRef}
        value={value}
        onChange={onChange}
        allowClear={allowClear}
        placeholder={`Search ${label}`}
      />
    </StyledSearchInputWithTypes>
  );
}

function ActivityTypeSearch({ selectedActivityType, onActivityTypeChange }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="activity-type-search">
      <Popover
        visible={open}
        onVisibleChange={setOpen}
        trigger="click"
        overlayClassName="activity-type-search-popover"
        content={
          <StyledPopover>
            <div
              className={`activity-type-icon ${
                selectedActivityType ? '' : 'active'
              }`}
              onClick={() => {
                onActivityTypeChange(null);
                setOpen(false);
              }}
            >
              <ActivityTypeIcon
                type="themes"
                color="white"
                withCircle
                circleColor={Colors.purple}
                size={10}
                width={20}
                height={20}
              />
              <span>Themes</span>
            </div>
            {ActivityTypes.withLabels.map((activityType) => (
              <div
                className={`activity-type-icon ${
                  selectedActivityType == activityType.value ? 'active' : ''
                }`}
                onClick={() => {
                  setOpen(false);
                  onActivityTypeChange(activityType.value);
                }}
                key={activityType.value}
              >
                <ActivityTypeIcon
                  type={activityType.value}
                  color="white"
                  withCircle
                  circleColor={Colors.activityTypeColors[activityType.value]}
                  size={10}
                  width={20}
                  height={20}
                />
                <span>{activityType.label}</span>
              </div>
            ))}
          </StyledPopover>
        }
      >
        <div className="activity-type-button">
          <ActivityTypeIcon
            type={selectedActivityType || 'themes'}
            color="white"
            withCircle
            circleColor={
              selectedActivityType
                ? Colors.activityTypeColors[selectedActivityType]
                : Colors.purple
            }
            size={14}
            width={26}
            height={26}
          />
          {open ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
        </div>
      </Popover>
    </div>
  );
}
